module.exports = __webpack_public_path__ + "assets/img/scenic-bg.ca2769be.png";